var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"21","viewBox":"0 0 24 21","fill":"none"}},[_c('path',{attrs:{"fill":"none","stroke":"black","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","d":"m3 21l7.548-7.548M21 3l-7.548 7.548m0 0L8 3H3l7.548 10.452m2.904-2.904L21 21h-5l-5.452-7.548"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }